/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getClasses = (schoolId) =>
  client.get(`/staff/school/${schoolId}/classes`);

const getStaffClasses = (schoolId, staffId) =>
  client.get(`/staff/${staffId}/school/${schoolId}/classes`);

const postionClass = (
  school_id,
  class_id,
  session_id,
  term_id,
  subjects_to_assess
) =>
  client.post(
    "/staff/class/assessment/position",
    {
      class_id,
      session_id,
      term_id,
      subjects_to_assess,
      school_id,
    },
  );

const getSingleClass = (class_id) =>
  client.get(`/staff/class/${class_id}`);

const getNumOfStudents = (class_id, school_id) =>
  client.get(`/staff/school/${school_id}/stat/class/${class_id}/students`);

const getNumOfClassSubjects = (class_id, school_id) =>
  client.get(`/staff/school/${school_id}/stat/class/${class_id}/subjects`);

const getClassAssessmentPercentage = (class_id, school_id) =>
  client.get(`/staff/school/${school_id}/stat/class/${class_id}/assessment`);

const getStudentsInClassPerformance = (
  class_id,
  school_id,
  termId,
  sessionId,
  limit = null
) => {
  const params = {};

  if (termId) {
    params.termId = termId;
  }

  if (limit) {
    params.limit = limit;
  }

  if (sessionId) {
    params.sessionId = sessionId;
  }

  return client.get(
    `/staff/school/${school_id}/class/${class_id}/performance/students`,
    {
      params: params,
    }
  );
};

const getNumberOfStudentsByGender = (
  class_id,
  school_id,
  termId,
  sessionId
) => {
  const params = {};

  if (termId) {
    params.termId = termId;
  }

  if (sessionId) {
    params.sessionId = sessionId;
  }

  return client.get(
    `/staff/school/${school_id}/stat/class/${class_id}/gender/students`,
    {
      params,
    }
  );
};

const getSubjectsInClass = (class_id, limit) => {
  const params = {};
  if (limit) {
    params.limit = limit;
  }
  return client.get(`/staff/class/${class_id}/subjects`, {
    params,
  });
};

const getStaffSubjectsInClass = (class_id, staff_id) => {
  return client.get(
    `/staff/class/${class_id}/subjects`,
  );
};

const getAssessmentPercentage = (class_id, school_id) =>
  client.get(`staff/school/${school_id}/stat/class/${class_id}/assessment`);

export default {
  getAssessmentPercentage,
  getClassAssessmentPercentage,
  getNumOfClassSubjects,
  getNumOfStudents,
  getClasses,
  getSingleClass,
  getStudentsInClassPerformance,
  getNumberOfStudentsByGender,
  getSubjectsInClass,
  postionClass,
  getStaffSubjectsInClass,
  getStaffClasses,
};
